import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    lastRoundLabel: 'Last giveaway',
    justNow: 'just now',
    minuteAgo: 'a minute ago',
    hourAgo: 'an hour ago',
    minutesAgoOne: '{{count}} minute ago',
    minutesAgoFew: '{{count}} minutes ago',
    minutesAgoMany: '{{count}} minutes ago',
    hoursAgoOne: '{{count}} hour ago',
    hoursAgoFew: '{{count}} hours ago',
    hoursAgoMany: '{{count}} hours ago',
    moreWinnersOne: 'and {{count}} more winner',
    moreWinnersFew: 'and {{count}} more winners',
    moreWinnersMany: 'and {{count}} more winners',
    whatIsItTitle: 'A case, given away',
    whatIsIt: 'We open it and hand out what drops',
    note: 'Giveaways run a few times a day',
  },
  ru: {
    lastRoundLabel: 'Прошлая раздача',
    justNow: 'только что',
    minuteAgo: 'минуту назад',
    hourAgo: 'час назад',
    minutesAgoOne: '{{count}} минуту назад',
    minutesAgoFew: '{{count}} минуты назад',
    minutesAgoMany: '{{count}} минут назад',
    hoursAgoOne: '{{count}} час назад',
    hoursAgoFew: '{{count}} часа назад',
    hoursAgoMany: '{{count}} часов назад',
    moreWinnersOne: 'и ещё {{count}} победитель',
    moreWinnersFew: 'и ещё {{count}} победителя',
    moreWinnersMany: 'и ещё {{count}} победителей',
    whatIsItTitle: 'Раздаём кейс',
    whatIsIt: 'Открываем его и отдаём то, что выпало',
    note: 'Раздачи проходят несколько раз в день',
  },
  uz: {
    lastRoundLabel: 'Oʻtgan ulashish',
    justNow: 'hozirgina',
    minuteAgo: 'bir daqiqa oldin',
    hourAgo: 'bir soat oldin',
    minutesAgoOne: '{{count}} daqiqa oldin',
    minutesAgoFew: '{{count}} daqiqa oldin',
    minutesAgoMany: '{{count}} daqiqa oldin',
    hoursAgoOne: '{{count}} soat oldin',
    hoursAgoFew: '{{count}} soat oldin',
    hoursAgoMany: '{{count}} soat oldin',
    moreWinnersOne: 'yana {{count}} gʻolib',
    moreWinnersFew: 'yana {{count}} gʻolib',
    moreWinnersMany: 'yana {{count}} gʻolib',
    whatIsItTitle: 'Keysni ulashamiz',
    whatIsIt: 'Ochamiz va undan tushgan narsani beramiz',
    note: 'Ulashish kuniga bir necha marta boʻladi',
  },
  fa: {
    lastRoundLabel: 'پخش قبلی',
    justNow: 'همین الان',
    minuteAgo: 'یک دقیقه پیش',
    hourAgo: 'یک ساعت پیش',
    minutesAgoOne: '{{count}} دقیقه پیش',
    minutesAgoFew: '{{count}} دقیقه پیش',
    minutesAgoMany: '{{count}} دقیقه پیش',
    hoursAgoOne: '{{count}} ساعت پیش',
    hoursAgoFew: '{{count}} ساعت پیش',
    hoursAgoMany: '{{count}} ساعت پیش',
    moreWinnersOne: '{{count}} برندهٔ دیگر',
    moreWinnersFew: '{{count}} برندهٔ دیگر',
    moreWinnersMany: '{{count}} برندهٔ دیگر',
    whatIsItTitle: 'یک کیس پخش می‌کنیم',
    whatIsIt: 'بازش می‌کنیم و هرچه بیفتد می‌دهیم',
    note: 'پخش‌ها روزی چند بار برگزار می‌شود',
  },
  pt: {
    lastRoundLabel: 'Último sorteio',
    justNow: 'agora mesmo',
    minuteAgo: 'há um minuto',
    hourAgo: 'há uma hora',
    minutesAgoOne: 'há {{count}} minuto',
    minutesAgoFew: 'há {{count}} minutos',
    minutesAgoMany: 'há {{count}} minutos',
    hoursAgoOne: 'há {{count}} hora',
    hoursAgoFew: 'há {{count}} horas',
    hoursAgoMany: 'há {{count}} horas',
    moreWinnersOne: 'e mais {{count}} vencedor',
    moreWinnersFew: 'e mais {{count}} vencedores',
    moreWinnersMany: 'e mais {{count}} vencedores',
    whatIsItTitle: 'Sorteamos uma caixa',
    whatIsIt: 'A gente abre e entrega o que cair',
    note: 'Os sorteios acontecem várias vezes por dia',
  },
  tr: {
    lastRoundLabel: 'Son çekiliş',
    justNow: 'az önce',
    minuteAgo: 'bir dakika önce',
    hourAgo: 'bir saat önce',
    minutesAgoOne: '{{count}} dakika önce',
    minutesAgoFew: '{{count}} dakika önce',
    minutesAgoMany: '{{count}} dakika önce',
    hoursAgoOne: '{{count}} saat önce',
    hoursAgoFew: '{{count}} saat önce',
    hoursAgoMany: '{{count}} saat önce',
    moreWinnersOne: 've {{count}} kazanan daha',
    moreWinnersFew: 've {{count}} kazanan daha',
    moreWinnersMany: 've {{count}} kazanan daha',
    whatIsItTitle: 'Kasa dağıtıyoruz',
    whatIsIt: 'Açıyoruz ve çıkanı veriyoruz',
    note: 'Çekilişler günde birkaç kez yapılır',
  },
});
